module.exports = __webpack_public_path__ + "static/media/fig_11a.ac649620.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/fig_11a.gif
// module id = 628
// module chunks = 0